import { UserState } from './types'

const initialUserState: UserState = {
    id: null,
    authenticated: false,
    unAuthorized: false,
    info: {
        id: null,
        username: '',
        firstName: '',
        lastName: '',
        permissions: [],
        roles: [],
    },

    dealer: {
        id: null,
        name: '',
        address1: '',
        address2: '',
        postalCode: '',
        city: '',
        countryCode: '',
        email: '',
        telephone: '',
        mobile: '',
        fax: '',
    },

    businessUnit: {
        id: null,
        name: '',
        internalName: '',
        address1: '',
        address2: '',
        postalCode: '',
        city: '',
        countryCode: '',
        email: '',
        telephone: '',
        mobile: '',
        fax: '',
        dealer_id: 1,
    },
    businessUnitBrand: {
        id: null,
        name: '',
    },
}

export default initialUserState
